import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { HighlightService } from 'src/app/@core/services/highligh.service';

@Component({
  selector: 'app-scroll',
  templateUrl: './scroll.component.html',
  styleUrls: ['./scroll.component.scss']
})
export class ScrollComponent implements OnInit {
  utils: any;
  highlighted: boolean = false;
  codeLight: string;
  codeDark: string;
  infoComponent: { titulo: string; descripcion: string; };
  constructor(
    private sanitizer: DomSanitizer,
    private highlightService: HighlightService) {
      this.utils = window.utils;
      this.codeLight=`<div class="scroll-light-govco cdn-scroll-dark"></div>`;
      this.codeDark= `<div class="scroll-dark-govco cdn-scroll-light"></div>`;
      
      this.infoComponent = {
        titulo: "Scroll-bar",
        descripcion: "Elemento de la interfáz gráfica que permite el desplazamiento vertical u horizontal de un contenedor asociado. Sin embargo, por usabilidad, recomendamos no utilizar este elemento para desplazamiento horizontal ya que desorienta al usuario, generando confusión entre la visualización del contenido y su ubicación dentro del scroll. Adicionalmente, dificulta la navegación del sitio teniendo activas las dos dimensiones. GOV.CO personaliza el estilo del scroll para dos usos:"
      }
  }

  ngAfterViewChecked() {
    if (!this.highlighted) {
      this.highlightService.highlightAll();
      this.highlighted = true;
    }
  }

  ngOnInit() {
    this.utils.init();
  }

}
